<!--  -->
<template>
  <div class="CustomTimer">
    <div class="CustomTimer_tip">交易时间</div>
    <div class="CustomTimer_time_box">
      <div
        v-for="(e, index) in customTimer"
        :key="e"
        @click="clickTag(index)"
        :class="{ active: Index === index }"
        class="CustomTimer_time"
      >
        {{ e }}
      </div>
    </div>
    <div class="CustomTimer_tip">自定义</div>
    <div class="custom_box">
      <div
        class="customBoxList_time"
        v-for="(e, index) in customBoxList"
        :class="{ active: timeindex === index }"
        @click="clickDatetimePicker(index)"
        :key="index"
      >
        {{ e }}
      </div>
      <div class="line"></div>
    </div>
    <div>
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @change="changePicker"
        :formatter="formatter"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Toast } from 'vant';

export default {
  name: 'CustomTimer',
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      customTimer: ['上个月', '近三个月'],
      customBoxList: {
        start: '请选择开始日期',
        end: '请选择结束日期',
      },
      Index: null,
      timeindex: null,
      startEnd: '',
      startDate: '',
      endDate: '',
    };
  },
  mounted() {
    const resultDate = new Date(
      new Date().getTime() - 365 * 2 * 24 * 3600 * 1000,
    );
    const month = resultDate.getMonth() + 1;
    const year = resultDate.getFullYear();
    this.minDate = new Date(year, month);
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}`;
      } if (type === 'month') {
        return `${val}`;
      }
      return val;
    },
    onConfirm() {
      if (
        this.timeindex !== null
        && (this.customBoxList.start !== '请选择开始日期'
          || this.customBoxList.end !== '请选择结束日期')
      ) {
        if (Number(this.startDate) > Number(this.endDate)) {
          Toast('结束时间不能小于开始时间');
          return;
        } if (Number(this.endDate) - Number(this.startDate) > 0.02) {
          Toast('最大时间跨度支持3个自然月');
          return;
        }

        this.$emit('getVal', {
          startDate: this.startDate,
          endDate: this.endDate,
          tranType: '',
          status: '3',
          month: '',
        });
      } else if (this.Index !== null) {
        this.$emit('getVal', {
          tranType: this.tranType,
          startDate: '',
          endDate: '',
          status: '2',
          month: '',
        });
      }
    },
    clickTag(i) {
      this.Index = i;
      this.timeindex = null;
      this.tranType = i + 1;
    },
    clickDatetimePicker(i) {
      this.Index = null;
      this.timeindex = i;
      this.timerSeletePicker(i);
    },
    timerSeletePicker(i) {
      // 解析
      const analysis = (date) => {
        const year = date.split('.')[0] * 1;
        const month = date.split('.')[1] * 1 - 1;
        console.log(year, month);
        return new Date(year, month);
      };
      // 判断点击的是哪个按钮
      const initSatrtEnd = this.customBoxList.start === '请选择开始日期'
        && this.customBoxList.end === '请选择结束日期';
      const initSatrtEndFc = (timer) => {
        const date = moment(new Date()).format('YYYY.MM');
        this.startDate = date;
        this.customBoxList[timer] = date;
        this.currentDate = analysis(date);
      };
      // eslint-disable-next-line no-shadow
      ((start, end, initSatrtEnd) => {
        if (i === start && initSatrtEnd) {
          // 当日期没有选择的时候
          initSatrtEndFc(start);
        } else if (i === end && initSatrtEnd) {
          if (initSatrtEnd) {
            initSatrtEndFc(end);
          }
        }
      })('start', 'end', initSatrtEnd);
      // 当有一方从来没有选择过
      if (i === 'start') {
        if (
          this.customBoxList.start === '请选择开始日期'
          && this.customBoxList.end !== '请选择结束日期'
        ) {
          this.customBoxList.start = this.endDate;
          this.startDate = this.endDate;
        }
      } else if (i === 'end') {
        if (
          this.customBoxList.start !== '请选择开始日期'
          && this.customBoxList.end === '请选择结束日期'
        ) {
          this.customBoxList.end = this.startDate;
          this.endDate = this.startDate;
        }
      }
      // 当所有都被选择过
      if (i === 'start') {
        if (
          this.customBoxList.start !== '请选择开始日期'
          && this.customBoxList.end !== '请选择结束日期'
        ) {
          this.currentDate = analysis(this.customBoxList.start);
        }
      } else if (i === 'end') {
        if (
          this.customBoxList.start !== '请选择开始日期'
          && this.customBoxList.end !== '请选择结束日期'
        ) {
          this.currentDate = analysis(this.customBoxList.end);
        }
      }
    },
    changePicker(picker) {
      const timer = `${picker.children[0].getValue()}.${picker.children[1].getValue()}`;
      if (this.timeindex === 'start') {
        this.customBoxList.start = timer;
        this.startDate = timer;
      } else if (this.timeindex === 'end') {
        this.customBoxList.end = timer;
        this.endDate = timer;
      }
    },
  },
};
</script>
<style scoped>
.CustomTimer {
  height: 300px;
  padding: 16px;
  overflow-y: scroll;
}
.CustomTimer_tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
  text-align: left;
}
.CustomTimer_time_box {
  display: flex;
  flex-direction: row;
  margin: 8px 0;
}
.CustomTimer_time_box .CustomTimer_time:last-child {
  margin-left: 16px;
}
.active {
  background: #ffffff;
  border: 1px solid #ff6538 !important;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ff6538 !important;
}
.timeActive {
  background: #ffffff;
  border: 1px solid #ff6538 !important;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ff6538 !important;
}
.customBoxList_time {
  border: 1px solid #eee;
  font-size: 14px;
  padding: 4px;
  color: #9ea7b4;
  width: 30%;
}
.CustomTimer_time {
  width: 104px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
}
.custom_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 8px;
  position: relative;
}
.line {
  width: 24px;
  height: 2px;
  background: #eee;
  position: absolute;
  top: 14px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
}
.custom_box >>> .van-field__control:disabled {
  text-align: center;
  border: 1px solid #eee;
}
.CustomTimer >>> .van-picker__cancel {
  display: none;
}
.CustomTimer >>> .van-picker__toolbar {
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
  z-index: 9;
}
.CustomTimer >>> .van-picker__confirm {
  width: 80%;
  background: olive;
  margin: 0 auto;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 8px;
  color: #fff;
}
</style>
